var _rect, _rect2, _rect3, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAllIconGrey(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 9.25098,
    y: 11,
    width: 12,
    height: 2,
    rx: 1,
    fill: "#ADB8CC"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 9.25098,
    y: 3,
    width: 12,
    height: 2,
    rx: 1,
    fill: "#ADB8CC"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 9.25098,
    y: 19,
    width: 12,
    height: 2,
    rx: 1,
    fill: "#ADB8CC"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.25098 6C5.35555 6 6.25098 5.10457 6.25098 4C6.25098 2.89543 5.35555 2 4.25098 2C3.14641 2 2.25098 2.89543 2.25098 4C2.25098 5.10457 3.14641 6 4.25098 6Z",
    fill: "#ADB8CC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.25098 14C5.35555 14 6.25098 13.1046 6.25098 12C6.25098 10.8954 5.35555 10 4.25098 10C3.14641 10 2.25098 10.8954 2.25098 12C2.25098 13.1046 3.14641 14 4.25098 14Z",
    fill: "#ADB8CC"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.25098 22C5.35555 22 6.25098 21.1046 6.25098 20C6.25098 18.8954 5.35555 18 4.25098 18C3.14641 18 2.25098 18.8954 2.25098 20C2.25098 21.1046 3.14641 22 4.25098 22Z",
    fill: "#ADB8CC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAllIconGrey);
export default __webpack_public_path__ + "static/media/all_icon_grey.18b355403bc541b16c3635f9e5af9b64.svg";
export { ForwardRef as ReactComponent };